__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "evo.portal.mfe";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@fluentui/react-components", "9.57.0", () => (Promise.all([__webpack_require__.e(359), __webpack_require__.e(209), __webpack_require__.e(995), __webpack_require__.e(717), __webpack_require__.e(622), __webpack_require__.e(579)]).then(() => (() => (__webpack_require__(5209))))));
			register("@fluentui/react-icons", "2.0.292", () => (Promise.all([__webpack_require__.e(359), __webpack_require__.e(445), __webpack_require__.e(995)]).then(() => (() => (__webpack_require__(8445))))));
			register("@fluentui/react", "8.121.13", () => (Promise.all([__webpack_require__.e(898), __webpack_require__.e(957), __webpack_require__.e(995), __webpack_require__.e(717)]).then(() => (() => (__webpack_require__(5898))))));
			register("@reduxjs/toolkit", "1.9.7", () => (__webpack_require__.e(327).then(() => (() => (__webpack_require__(9327))))));
			register("axios", "0.27.2", () => (__webpack_require__.e(854).then(() => (() => (__webpack_require__(854))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(995)]).then(() => (() => (__webpack_require__(7950))))));
			register("react-redux", "8.0.5", () => (Promise.all([__webpack_require__.e(166), __webpack_require__.e(995), __webpack_require__.e(717)]).then(() => (() => (__webpack_require__(2166))))));
			register("react-responsive", "9.0.2", () => (Promise.all([__webpack_require__.e(237), __webpack_require__.e(995)]).then(() => (() => (__webpack_require__(5237))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(810), __webpack_require__.e(995)]).then(() => (() => (__webpack_require__(4810))))));
			register("react-toastify", "9.1.3", () => (Promise.all([__webpack_require__.e(145), __webpack_require__.e(995)]).then(() => (() => (__webpack_require__(2145))))));
			register("react", "17.0.2", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(5043))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};